
import { defineComponent, ref, onMounted, reactive, computed, toRefs } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { User } from "@/classes/user";
import axios from '../../../axios'

export default defineComponent({
    setup() {
    const store = useStore();
    const items = ref([]);
    const current = ref(0);
    const router = useRouter();
    const fields = ref([
      {
        title: "ID",
        dataIndex: "outage_code",
      },
    ]);

    const notification = async (payload = { page: 1 }) => {
      await store.dispatch("NotificationVendor/index", payload).then((res) => {
        items.value = res.data;
        current.value = res.data.current_page;
      });
    };

    const filterRecord = (payload: any) => {
      notification(payload);
      // console.log(payload);
    };

    async function goToNotif(notif: any) {
      await store.dispatch("NotificationVendor/read", { id: notif.id }).then(() => {
       
          window.location.href =
            "/invoice/edit/" + notif.invoice_id;
  
        
      });
    }

    const changeNotifPage = (page: any) => {
      notification({ page: page });
    };
    onMounted(() => {
      notification();
    });
    return {
      items,
      filterRecord,
      fields,
      current,
      changeNotifPage,
      goToNotif,
    };
  },
})
